import { defer } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { createRef, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import KeyConstants from "../../constants/keyConstants";
import PubSubTopics from "../../constants/pubSubTopics";
import Dimensions from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import { disableWhenIos } from "../../utils/codeSplit";
import FormTextField from "./FormTextField";

const { MAX_ITEM_TEXT_WIDTH } = Dimensions;

export default class FormEditableLabel extends PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onLabelChange = this.onLabelChange.bind(this);
    this.stopEditingLabel = this.stopEditingLabel.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.getSizeFunction = this.getSizeFunction.bind(this);

    this.nodeRef = createRef();

    //#!if iOS !== true && readonly !== true
// this.state = { isEditing: props.disabled ? false : this.props.isEditing, staticMaxWidth: 0 };
    //#!else
    this.state = { isEditing: false };
    //#!endif
  }

  componentDidMount() {
    this.updateStaticMaxWidth();
  }

  componentDidUpdate() {
    this.updateStaticMaxWidth();
  }

  updateStaticMaxWidth() {
    if (this.nodeRef && this.nodeRef.current && this.nodeRef.current.clientWidth !== this.state.staticMaxWidth) {
      this.setState({ staticMaxWidth: this.nodeRef.current.clientWidth });
    }
  }

  getTextValue() {
    return this.props.value;
  }

  onKeyDown(e) {
    // If we are not editing, do nothing.
    if (!this.state.isEditing) {
      return;
    }

    // If the user hits ENTER or TAB, we want to stop editing the label
    // But we also want to prevent the default behaviour of the keystroke
    // so that TAB doesn't shift focus to the next editable item.
    // It just doesn't feel right for inline edits to randomly jump elsewhere
    // (such as the inspector) on TAB.
    // Especially because that then prevents Undo from working...
    switch (e.key) {
      // Tab will lose focus so commit the change
      case KeyConstants.Tab:
      case KeyConstants.Enter: {
        this.stopEditingLabel();
        e.stopPropagation();
        e.preventDefault();
        break;
      }
    }
  }

  onClick(e) {
    // To stop the outside click when operating in the label editing
    if (this.state.isEditing) {
      e.stopPropagation();
    }
  }

  onDoubleClick(e) {
    // To stop the outside click when operating in the label editing
    //#!if readonly !== true
// e.stopPropagation();
// this.setEditing(true);
    //#!endif
  }

  setEditing(value) {
    //#!if iOS !== true && readonly !== true
// if (!this.props.disabled) {
// const isEditing = this.state.isEditing;
// if (isEditing !== value) {
// this.setState({ isEditing: value });
// if (this.props.onChangeEditing) {
// this.props.onChangeEditing(value);
// }
// }
// }
    //#!endif
  }

  onLabelChange(label) {
    this.stopEditingLabel();
    this.props.onChange(label);
  }

  stopEditingLabel() {
    this.setEditing(false);
    defer(() => PubSub.publish(PubSubTopics.inlineEditingEnded, {}));
  }

  getSizeFunction(value) {
    if (this.props.getSizeFunction) {
      return this.props.getSizeFunction(value, this.state.staticMaxWidth || MAX_ITEM_TEXT_WIDTH);
    }
  }

  render() {
    const { displayValue, value, placeholder, multiline, allowNewLine, isStruckOut } = this.props;

    const { isEditing } = this.state;

    const classes = [
      "formEditableLabelLabel",
      isEditing ? "isEditing" : "",
      multiline ? "" : "singleline",
      isStruckOut ? "isStruckOut" : ""
    ];

    return (
      <div
        className="formEditableLabelContainer"
        onClick={this.onClick}
        onDoubleClick={disableWhenIos(this.onDoubleClick)}
        onKeyDown={this.onKeyDown}
        ref={this.nodeRef}
      >
        <div className={classes.join(" ")}>{displayValue ? displayValue : <span>{value}</span>}</div>
        {isEditing ? (
          <div className={`formEditableLabelTextField${multiline ? `` : ` singleline`}`}>
            <FormTextField
              value={value}
              placeholder={placeholder}
              multiline={multiline}
              allowNewLine={allowNewLine}
              autoFocus={true}
              onChange={this.onLabelChange}
              getSizeFunction={this.getSizeFunction}
              onBlur={this.stopEditingLabel}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

FormEditableLabel.propTypes = {
  isEditing: PropTypes.bool,
  displayValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypeShapes.elementOrArray,
    ImmutablePropTypes.list
  ]),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  multiline: PropTypes.bool,
  allowNewLine: PropTypes.bool,
  numeric: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeEditing: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  // The function can receive the static max width when calling
  // (value, staticMaxWidth) => ({width: number, height: number})
  getSizeFunction: PropTypes.func,
  disabled: PropTypes.bool,
  isStruckOut: PropTypes.bool
};
